@switch (columnName) {
  @case ('length') {
    {{ form.dimension.length.value + ' ' }}
    {{ dimensionUnit[form.dimension.dimensionsUnit.value] | translate }}
  }
  @case ('breadth') {
    {{ form.dimension.breadth.value + ' ' }}
    {{ dimensionUnit[form.dimension.dimensionsUnit.value] | translate }}
  }
  @case ('depth') {
    {{ form.dimension.depth.value + ' ' }}
    {{ dimensionUnit[form.dimension.dimensionsUnit.value] | translate }}
  }
  @case ('volume') {
    {{ form.volume.value + ' ' }}
    {{ 'tonnes' | translate }}
  }
  @case ('edit') {
    @if (!hideButtons) {
      <button mat-button (click)="buttonFunctions.edit()">
        <mat-icon>edit</mat-icon>
      </button>
    }
  }
  @case ('delete') {
    @if (!hideButtons) {
      <button mat-button (click)="buttonFunctions.delete()">
        <mat-icon>delete</mat-icon>
      </button>
    }
  }
  @default {
    {{ form.get(columnName)?.value }}
  }
}
